import { Injectable } from '@angular/core';
import { ApiHttpService } from './api_http.service';
import { B2bHttpService } from './b2b_http.service';
import { map } from 'rxjs/operators';

@Injectable()
export class UserService {
  constructor(private apiHttp: ApiHttpService,
    private b2bHttp: B2bHttpService) { }

  createUser(user, useAccountSystem) {
    if (useAccountSystem) {
      let registrationArgs = this.getCreateAccountArgs(user);
      return this.apiHttp.post('account_system/create_account', registrationArgs);
    } else {
      return this.b2bHttp.post('register.json', user);
    }
  }

  isValidPasswordToken(password_token) {
    return this.apiHttp.get('users/password/is_valid_password_token', { reset_password_token: password_token }).pipe(
      map((data: any) => data.response));
  }

  updatePassword(token, password, confirmPassword, email = null) {
    let updateParams = this.setUpdatePasswordParams(token, password, confirmPassword, email);
    return this.apiHttp.put('users/password', updateParams).pipe(
      map((data: any) => data.response.user));
  }

  emailPasswordLogin(email, password) {
    return this.apiHttp.post('users/login', this.setLoginParams(email, password)).pipe(
      map((data: any) => data.response.utoken));
  }

  private setLoginParams(email, password) {
    return {
      user: {
        email: email,
        password: password,
        remember_me: '0'
      }
    };
  }

  private setUpdatePasswordParams(reset_token, password, confirmPassword, email) {
    return {
      user: {
        reset_password_token: reset_token,
        password: password,
        password_confirmation: confirmPassword,
        email: email
      }
    };
  }

  private getCreateAccountArgs(user) {
    let params = {
      admin_info: {
        email: user.email,
        password: user.password,
        first_name: user.name
      },
      action_params: {
        install_step: user.not_finished_registration === true ? 'not_finished_registration' : null,
        captcha_token: user.capcha_token
      },
      product_category: user.productIntent
    };

    if (user.campaign_params) {
      params.action_params['campaign_params'] = user.campaign_params;
    }

    return params;
  }
}
